import { USER_NOTIFICATIONS_CRUD_ACTION_CREATORS } from '../actions/user_notifications_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { DEFAULT_SORTER, ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { defaultPagination } from '../components/WorkOrderTable/config/pagination/pagination';
const queryString = require('qs');

export const userNotificationsRestCrudThunksForBuyer = new RestCrudThunks(
	'user_notifications',
	'user_notification',
	'userNotification',
	'userNotifications',
	USER_NOTIFICATIONS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'notification/'
);
export const userNotificationsRestCrudThunksForSupplier = new RestCrudThunks(
	'user_notifications',
	'user_notification',
	'userNotification',
	'userNotifications',
	USER_NOTIFICATIONS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'notification/'
);

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

export const parseURL = (
	handleQueryParams,
	history,
	location,
	preAppliedFilters,
	initialPagination,
	initialSorting,
	initialFilters = {}
) => {
	let pagination = initialPagination || defaultPagination;
	let sorting = initialSorting || DEFAULT_SORTER;
	let filters = { ...preAppliedFilters, ...initialFilters };
	if (handleQueryParams && location) {
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString, {
			decoder(str, decoder, charset) {
				const strWithoutPlus = str.replace(/\+/g, ' ');
				if (charset === 'iso-8859-1') {
					return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
				}

				const keywords = {
					true: true,
					false: false,
					null: null,
					undefined: undefined,
				};
				if (str in keywords) {
					return keywords[str];
				}

				try {
					return decodeURIComponent(strWithoutPlus);
				} catch (e) {
					return strWithoutPlus;
				}
			},

			arrayLimit: 1000,
			parseArrays: true,
		});

		const {
			current = pagination.current,
			pageSize = pagination.pageSize,
			sort_by = sorting.sort_by,
			order = sorting.order,
			...notificationFilters
		} = queryParams;

		pagination = { current: parseInt(current), pageSize: parseInt(pageSize) };
		sorting = { sort_by, order };
		filters = {
			...(initialFilters || {}),
			...(notificationFilters || {}),
			...preAppliedFilters,
		};
	}
	return { pagination, sorting, filters };
};

const markAllUserNotificationsRead = (userType) => (entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(baseUrl + `/api/v1/${userType}/notification/user_notifications/has_seen_until`, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: {
						...entity,
					},
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};
export const markAllUserNotificationsReadForBuyer = markAllUserNotificationsRead(ROLE_TYPES.BUYER);
export const markAllUserNotificationsReadForSupplier = markAllUserNotificationsRead(
	ROLE_TYPES.SUPPLIER
);

const markUserNotificationsRead = (userType) => (notificationType, entityId) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateStart({}));

			fetchUtils
				.patch(
					baseUrl +
						`/api/v1/${userType}/notification/user_notifications/has_seen_by_type/${notificationType}/${entityId}`,
					{
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: {},
					}
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
						reject(d.message);
					} else {
						dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(USER_NOTIFICATIONS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
					reject(d.message);
				});
		});
	};
};
export const markUserNotificationsReadForBuyer = markUserNotificationsRead(ROLE_TYPES.BUYER);
export const markUserNotificationsReadForSupplier = markUserNotificationsRead(ROLE_TYPES.SUPPLIER);
